import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCloud66Component } from './simple-icons-cloud66.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCloud66Component ],
    exports:      [ SimpleIconsCloud66Component ],
    bootstrap:    []
})
export class SimpleIconsCloud66Module {}
